import getCoreLayoutStore from "../../stores/core/core-layout-store";
import ET3Div from "../et3-div";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";

const Et3Collapsible = withLiteObserverAndTheme<{
  children?: React.ReactNode;
  sectionId: string;
  defaultOpen: boolean;
}>((props) => {
  const { children = null, sectionId, defaultOpen, theme } = props;
  const { colors } = theme;
  const isOpen = getCoreLayoutStore().isSectionOpen(sectionId, defaultOpen);

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={0}
      height={0}
      fDirection="column"
      alignItems="stretch"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={{ width: "100%", display: isOpen ? "flex" : "none" }}
      onClick={() => {}}
    >
      {children}
    </ET3Div>
  );
});
export default Et3Collapsible;
